import { Text } from "@mantine/core";
import { PillButton } from "./PillButton";
import { useStaffMember } from "../../../hooks/core/useStaffMember";

export function StaffLink(props) {
  // If staff object is provided directly
  if ("staff" in props) {
    const { staff } = props;
    if (!staff) {
      return (
        <Text size="sm" c="dimmed">
          Unassigned
        </Text>
      );
    }

    return (
      <PillButton
        leftLabel={
          <Text size="xs" c="#FFBF00">
            {staff.department || "Staff"}
          </Text>
        }
        rightLabel={staff.displayName || staff.email}
        color="blue"
        variant="filled"
      />
    );
  }

  // If staffId is provided
  const { staffId } = props;
  const { staffMember, loading } = useStaffMember(staffId);

  if (loading) {
    return (
      <Text size="sm" c="dimmed">
        Loading...
      </Text>
    );
  }

  if (!staffId || !staffMember) {
    return (
      <Text size="sm" c="dimmed">
        Unassigned
      </Text>
    );
  }

  return (
    <PillButton
      leftLabel={
        <Text size="xs" c={props?.style?.color || "blue"}>
          {`${staffMember.department}: ${staffMember.jobTitle}`}
        </Text>
      }
      rightLabel={
        <Text size="xs" c={props?.style?.rightLabelColor || "#00CCCC"}>
          {staffMember.displayName || staffMember.email}
        </Text>
      }
      color={props?.style?.color || "blue"}
      style={{ width: "auto" }}
    />
  );
}

export default StaffLink;
